/*!
 *
 *  index.js
 *
 */
import { createApp } from 'vue';
export default function () {
    var app = createApp({
        data: function () {
            return {
                senko: 'すべて',
            };
        },
    });
    app.mount('#index');
}
;
